import React, {useState, useEffect} from 'react'
import blob from '../assets/svgs/background-blob.svg'
import woman from '../assets/svgs/woman.svg'
import man from '../assets/svgs/man.svg'
import windingArrow from '../assets/svgs/winding-arrow.svg'
import board from '../assets/svgs/board.svg'
import jotter from '../assets/svgs/jotter.svg'
import Button from '../components/Button'
import CalendarSection from '../components/calendar'
import Header from '../components/Header'
import Footer from '../components/Footer'
import { useNavigate } from 'react-router-dom'
// import Web3 from 'web3'

declare global {
  interface Window {
    ethereum?: any;
  }
}

const Hero = () => {
  const navigate = useNavigate()

  const [walletAddress, setWalletAddress] = useState("");
  const [isAutoConnectEnabled, setIsAutoConnectEnabled] = useState<boolean>(false);


  useEffect(() => {
    getCurrentWalletConnected();
    addWalletListener();
  }, [walletAddress]);

  const connectWallet = async () => {
    if (typeof window !== 'undefined' && typeof window.ethereum !== 'undefined') {
      try {
        /* MetaMask is installed */
        const accounts = await window.ethereum.request({
          method: 'eth_requestAccounts',
        });
        setWalletAddress(accounts[0]);
        console.log(accounts[0]);
      } catch (err: any) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      alert('Please install MetaMask')
      console.log('Please install MetaMask');
    }
    
  };

  const getCurrentWalletConnected = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      try {
        const accounts = await window.ethereum.request({
          method: "eth_accounts",
        });
        if (accounts.length > 0) {
          setWalletAddress(accounts[0]);
          console.log(accounts[0]);
          
        } else {
          console.log("Connect to MetaMask using the Connect button");
        }
      } catch (err: any) {
        console.error(err.message);
      }
    } else {
      /* MetaMask is not installed */
      console.log("Please install MetaMask");
    }
  };
  const disconnectWallet = () => {
    setWalletAddress('');
    setIsAutoConnectEnabled(false);
    // window.location.reload();
    console.log('Wallet disconnected');
  };

  
  // Auto connect the wallet on initial load
  React.useEffect(() => {
    if (isAutoConnectEnabled) {
      connectWallet();
    }
  }, [isAutoConnectEnabled]);


  const addWalletListener = async () => {
    if (typeof window != "undefined" && typeof window.ethereum != "undefined") {
      window.ethereum.on("accountsChanged", (accounts: string[]) => {
        setWalletAddress(accounts[0]);
        console.log(accounts[0]);
      });
    } else {
      /* MetaMask is not installed */
      setWalletAddress("");
      // window.location.reload();
    }
  };

  const handleExploreButton = () => {
    if (walletAddress && walletAddress.length > 0 ){
      navigate("/dashboard")
    }else{
      connectWallet()
    }
  }

  return (
    <>
    <Header/>
    <div className='relative'>
      <div className='absolute left-[37.5%] mt-10'>
        <img src = {blob} alt = "blob" />
      </div>
      <div className='absolute left-[48%] mt-80'>
        <img src = {blob} alt = "blob" />
      </div>
      <div className='w-[100%] grid grid-cols-[54%_46%]'>
        <div className='pl-24 mt-20  font-poppins'>
          <p className='text-sm text-main-blue'>YOUR PATH TO PROFESSIONAL SUCCESS STARTS HERE</p>
          <h1 className='text-5xl font-bold mt-5 text-main-black tracking-wider font-inter'>Launch a </h1>
          <h1 className='text-5xl font-bold mt-3 text-main-black tracking-wider font-inter'>new chapter in </h1>
          <h1 className='text-5xl font-bold mt-3 text-main-black tracking-wider font-inter'>your <span className='text-deep-main-blue'>career</span> with us</h1>
          <p className='mt-10 text-main-blue text-2xl'>Prepare for your dream job today</p>
          <div className='w-[100%] mt-[-2%]'>
            <img src = {windingArrow} alt = "blob" className = 'ml-[55%]'/>
          </div>
          <div className = "w-[130%] ml-[-5%] border border-[rgba(0,_0,_0,_0.25)] grid grid-cols-[2%_37.5%_37.5%_23%] py-3 px-4 rounded-[30px]">
            <div></div>
            <div className='grid grid-cols-[30%_60%_10%]'>
              <img  src= {board} alt = ""/>
              <p className='text-main-black font-[275px]'>Interview practice sessions</p>
            </div>
            <div className='grid grid-cols-[20%_70%_10%]'>
              <img  src= {jotter} alt = ""/>
              <p className='text-main-black font-[275px] text-'>Review your certificates and resume</p>
            </div>
            <div className='flex items-center justify-center'>
            <Button onClick={handleExploreButton}>
            {walletAddress && walletAddress.length > 0 ? "Explore Now" : "Connect Wallet"}
            </Button>
            </div>
          </div>
        </div>
        <div className='relative flex'>
          <div className=''>
            <img  src= {woman} alt='woman hero' className='mt-[-5%]'/>
          </div>
          <div className=''>
            <img  src= {man} alt='man hero' className='mt-[40%] ml-[28%]'/>
          </div>
        </div>
      </div>
      <CalendarSection />
    </div>
    <Footer />
    </>
  )
}

export default Hero